
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ProjectsMultiselectOption from "@/entities/ProjectsMultiselectOption";

  @Component
  export default class ProjectMultiselectOption extends Vue {
    @Prop({ type: Object, required: true }) readonly option!: ProjectsMultiselectOption;
    @Prop({ type: Boolean, default: false }) readonly selectedInline!: boolean;

    get optionClasses(): Record<string, boolean> {
      return {
        "flex-col": !this.selectedInline,
        "items-center": this.selectedInline,
      };
    }

    get displayName(): string {
      // Prioritize firstname + lastname if available
      if (this.option.firstname && this.option.lastname) {
        return `${this.option.firstname} ${this.option.lastname}`;
      }
      // Fall back to client_name if it exists
      if (this.option.client_name) {
        return this.option.client_name;
      }
      // Last resort - show at least something
      return this.option.firstname || this.option.lastname || 'Unknown Client';
    }

    get preferredNameDifferent(): boolean {
      return Boolean(
        this.option.preferred_name && 
        this.option.preferred_name.trim() !== '' &&
        this.option.preferred_name !== this.displayName
      );
    }

    get contactInfo(): string {
      const parts: string[] = [];
      if (this.option.phone_number) {
        parts.push(this.option.phone_number);
      }
      if (this.option.email_address) {
        parts.push(this.option.email_address);
      }
      return parts.join(' • ');
    }

    get hasSecondaryInfo(): boolean {
      return this.preferredNameDifferent || Boolean(this.contactInfo);
    }
  }
